const { match: pathMatch, compile: pathCompile } = require('path-to-regexp');
// import type { Language } from '../config/languages';

function isObjectEmpty(object) {
    return Object.keys(object).length === 0;
}

function getLocalizedPath(languageRoutes, actualPath) {
    if (!languageRoutes) {
        return null;
    }

    let localizedPath = null;

    for (const [route, localizedRoute] of Object.entries(languageRoutes)) {
        const match = pathMatch(route)(actualPath);

        if (match) {
            localizedPath = pathCompile(localizedRoute)(match.params);

            break;
        }
    }

    return localizedPath;
}

exports.getLocalizedPath = (
    originalPath /* : string */,
    locale /* : string */,
    languages /* : Language[] */,
    redirect = false,
) => {
    const defaultLanguage = languages.find(lang => lang.default);

    if (!defaultLanguage) {
        throw new Error('Default language has to be specified in the language configuration.');
    }
    let keyPath = originalPath.replace(/(\w+)\/$/, '$1');

    // Detect 404
    if (keyPath.match(/^\/?404\/?/gm)) keyPath = 'notFound';

    const lang = languages.find(lang => lang.locale === locale);

    if (!lang) {
        if (process.env.NODE_ENV === 'development') {
            console.warn(
                `Locale ${lang} not found in the list of provided languages: ${languages
                    .map(l => l.locale)
                    .toString()}.`,
            );
        }

        return undefined;
    }

    const isDefault = locale === defaultLanguage.locale;
    const localizedPath = getLocalizedPath(lang && lang.routes, keyPath);

    if (!localizedPath && !redirect) {
        if (process.env.NODE_ENV === 'development') {
            console.warn(
                `Some routes are not available and will result in 404.\n There is no transalation for ${originalPath} in language ${locale}.`,
            );
        }

        return undefined;
    }

    if (!localizedPath && redirect) {
        if (process.env.NODE_ENV === 'development') {
            console.warn(`Localized path for ${originalPath} was not provided and will result in 404 `);
        }

        return lang.routes.notFound;
    }

    return isDefault ? localizedPath : `/${locale}${localizedPath}`;
};
